import { Injectable, InjectionToken, Provider } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Injectable()
export class IconRegistryService {

  private iconSetFolder = 'assets/iconsets';

  constructor(private matIcon: MatIconRegistry, private sanitize: DomSanitizer) {
    this.matIcon.addSvgIconSetInNamespace('navigation', this.makeMaterialSetFolder('svg-sprite-navigation.svg'));
    this.matIcon.addSvgIconSetInNamespace('action', this.makeMaterialSetFolder('svg-sprite-action.svg'));
    this.matIcon.addSvgIconSetInNamespace('content', this.makeMaterialSetFolder('svg-sprite-content.svg'));
    this.matIcon.addSvgIconSetInNamespace('locales', this.makeMaterialSetFolder('flag-set.svg'));
    this.matIcon.addSvgIconSetInNamespace('hardware', this.makeMaterialSetFolder('svg-sprite-hardware.svg'));
    this.addInSet({
      namespace: 'images',
      folder: 'os-images',
      filename: 'os-iconset.svg'
    });
  }

  private makeMaterialSetFolder(fileName: string): SafeResourceUrl {
    return this.sanitize.bypassSecurityTrustResourceUrl(`${this.iconSetFolder}/${fileName}`);
  }

  private createIconPath(folder: string, filename: string): SafeResourceUrl {
    return this.sanitize.bypassSecurityTrustResourceUrl(`assets/${folder}/${filename}`);
  }

  public addInSet(config: { namespace?: string, folder: string, filename: string }) {
    if (config.filename === undefined) {
      this.matIcon.addSvgIconSet(this.createIconPath(config.folder, config.filename));
    } else {
      this.matIcon.addSvgIconSetInNamespace(config.namespace, this.createIconPath(config.folder, config.filename));
    }
  }

}

export const IconRegistryFabric: (matIcon: MatIconRegistry, sanitize: DomSanitizer) => IconRegistryService =
  (matIcon: MatIconRegistry, sanitize: DomSanitizer) => {
    return new IconRegistryService(matIcon, sanitize);
  };

export const IconRegistryProvider: Provider = {
  provide: new InjectionToken('iconRegistry'),
  useFactory: IconRegistryFabric,
  deps: [MatIconRegistry, DomSanitizer],
  multi: true
};
